import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { t } from "../../services/HelperService";

const initialsOf = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const colorFromString = (str, s = 55, l = 40) => {
    if (!str) return `hsl(210 ${s}% ${l}%)`;
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = Math.abs(hash) % 360;
    return `hsl(${h} ${s}% ${l}%)`;
};

export default function AssigneeBadge({
    id,
    name,
    kind = null,
    size = 28,
    showUnassigned = true,
    onClick,
    disabled = false
}) {
    const label = (name || "").trim();
    const clickable = !!onClick && !disabled;

    if (!label) {
        if (!showUnassigned) return null;
        const style = {
            width: size, height: size, borderRadius: "50%",
            border: "2px dashed #adb5bd", color: "#adb5bd",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            fontWeight: 700, fontSize: Math.round(size * 0.5), background: "transparent",
            cursor: clickable ? "pointer" : "default", opacity: disabled ? 0.55 : 1
        };
        return (
            <>
                <div
                    id={id}
                    style={style}
                    aria-label="Unassigned"
                    aria-disabled={disabled || undefined}
                    role={clickable ? "button" : undefined}
                    tabIndex={clickable ? 0 : undefined}
                    onClick={clickable ? onClick : undefined}
                    onKeyDown={(e) => { if (clickable && (e.key === "Enter" || e.key === " ")) onClick(); }}
                >?</div>
                <UncontrolledTooltip target={id} placement="top">
                    {t("application_strings.views.chat.assigneeBadge.unassigned")}
                </UncontrolledTooltip>
            </>
        );
    }

    const style = {
        width: size, height: size, borderRadius: "50%",
        backgroundColor: colorFromString(label, 55, 40),
        color: "#fff", display: "inline-flex",
        alignItems: "center", justifyContent: "center",
        fontWeight: 700, fontSize: Math.round(size * 0.45),
        cursor: clickable ? "pointer" : "default", opacity: disabled ? 0.55 : 1
    };

    return (
        <>
            <div
                id={id}
                style={style}
                aria-label={label}
                aria-disabled={disabled || undefined}
                role={clickable ? "button" : undefined}
                tabIndex={clickable ? 0 : undefined}
                onClick={clickable ? onClick : undefined}
                onKeyDown={(e) => { if (clickable && (e.key === "Enter" || e.key === " ")) onClick(); }}
            >
                {initialsOf(label)}
            </div>
            <UncontrolledTooltip target={id} placement="top">
                {t("application_strings.views.chat.assigneeBadge.assigned", { label: label, kind: kind ? ` (${kind})` : "" })}
            </UncontrolledTooltip>
        </>
    );
}
